import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncateNumPipe } from './truncate.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ TruncateNumPipe ],
    exports: [ TruncateNumPipe ],
})
export class TruncateNumPipeModule {}
